import { Typography } from "@mui/material";
import { View } from "../../View";
import { makeStyles } from "@mui/styles";
import { OptimiseResultsPerRoute } from "./OptimiseResultsPerRoute";

const useStyles = makeStyles({
  container: {
    maxHeight: "500px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  sectionHeader: {
    fontSize: "16px",
    fontWeight: "bold",
  },
});

export const OptimiseResultsModalContent = ({ currentRoute, otherRoutes }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Typography className={styles.sectionHeader}>
        EDITED ROUTE: {currentRoute?.routeCode}
      </Typography>
      <OptimiseResultsPerRoute route={currentRoute} />

      {otherRoutes && !!otherRoutes.length && (
        <Typography className={styles.sectionHeader}>
          IMPACTED ROUTES
        </Typography>
      )}
      {otherRoutes &&
        otherRoutes.map((route) => (
          <OptimiseResultsPerRoute
            key={route.routeCode}
            route={route}
            impactedRoute
          />
        ))}
    </View>
  );
};
